export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 10_05.f7f6ca3e.jpg";